export default __webpack_public_path__ + "static/leao-de6787cf6c9a49ccf56d77e869a446b6.png";